export const mapCategoryImage = (slug) => {
    try {
        return require(`../../assets/images/landingPages/types/${slug}.png`);
    } catch (e) {
        console.warn(e);
    }
    return '';
};

export const mapBackgroundImage = (slug) => {
    try {
        return require(`../../assets/images/landingPages/backgrounds/${slug}-background.png`);
    } catch (e) {
        console.warn(e);
    }
    return '';
};